export default __webpack_public_path__ + "static/media/beas river.a78f54de.jpg";